// export const BASE_API_DEV   = "http://localhost:4000"
export const BASE_API_DEV   = "https://isms.impuls.run/api"

export const BASE_API_PROD  = "https://sman5bdg.api.isms.impuls.id"

export const SEKOLAH_KODE = "sman5bdg"

export const APP_TIMEZONE = "Asia/Jakarta"